
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-orange-600 via-orange-500 to-orange-400 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/eda624f9ba106bff0baccd0411b07fc5.jpg"
                alt="Shocker Solutions"
                className="h-10 w-auto"
              />
              <span className="text-lg font-bold">SHOCKER SOLUTIONS</span>
            </div>
            <p className="text-sm text-white/90 mb-4">
              Expert reviews and honest recommendations for off-grid living and camping gear.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-base mb-4">PRODUCTS</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-sm text-white/90 hover:text-white transition-colors">
                  Solar Generators
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm text-white/90 hover:text-white transition-colors">
                  Refrigeration
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm text-white/90 hover:text-white transition-colors">
                  Camping Showers
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base mb-4">RESOURCES</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/reviews" className="text-sm text-white/90 hover:text-white transition-colors">
                  Video Reviews
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-sm text-white/90 hover:text-white transition-colors">
                  Buying Guides
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-sm text-white/90 hover:text-white transition-colors">
                  Off-Grid Tips
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-base mb-4">LEGAL</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-sm text-white/90 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/legal/affiliate-disclosure" className="text-sm text-white/90 hover:text-white transition-colors">
                  Affiliate Disclosure
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy-policy" className="text-sm text-white/90 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/terms" className="text-sm text-white/90 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 mb-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/80">© 2025 ShockerSolutions.com. All rights reserved.</p>
          
          <div className="flex items-center gap-4">
            <a
              href="https://youtube.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-lg border-2 border-white/30 hover:border-white hover:bg-white/10 transition-all cursor-pointer"
              aria-label="YouTube"
            >
              <i className="ri-youtube-line text-lg"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-lg border-2 border-white/30 hover:border-white hover:bg-white/10 transition-all cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100064233546144"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-lg border-2 border-white/30 hover:border-white hover:bg-white/10 transition-all cursor-pointer"
              aria-label="Facebook"
            >
              <i className="ri-facebook-line text-lg"></i>
            </a>
          </div>
        </div>

        <div className="text-center">
          <p className="text-xs text-white/70 leading-relaxed max-w-4xl mx-auto">
            <strong>Affiliate Disclosure:</strong> ShockerSolutions.com participates in affiliate programs and may earn commissions from qualifying purchases made through links on this site. This helps support our content at no extra cost to you. We only recommend products we've personally tested and believe in.
          </p>
        </div>
      </div>
    </footer>
  );
}
